import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/operadora";

/**
 * Classe de gerenciamento de chamadas da API dos Operadora
 *
 * @class
 */
export default class OperadoraApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe OperadoraApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
 * @returns Lista de Operadora (ComboBox)
 */
    listCbo(dataInicio?: string, dataFim?: string, exibirParticulares?: boolean, itensPeriodo?: boolean) {
        // Define os parâmetros a serem enviados na requisição
        const parameters: { [key: string]: any } = {};

        // Adiciona os parâmetros de data, se definidos
        if (dataInicio) {
            parameters.dataInicio = dataInicio;
        }

        if (dataFim) {
            parameters.dataFim = dataFim;
        }

        // Define os parâmetros booleanos com valores padrão
        parameters.itensPeriodo = itensPeriodo ?? false;
        parameters.exibirParticulares = exibirParticulares ?? false;

        // Monta a URL com os parâmetros no formato correto
        const url = `${controller}/listar-operadoras-combo/${parameters.exibirParticulares}/${parameters.itensPeriodo}`;

        // Faz a chamada à API
        return this.api<ApplicationModule[]>(url, {
            method: "GET",
            params: {
                dataInicio: parameters.dataInicio,
                dataFim: parameters.dataFim
            }
        });
    }

      /**
       * @returns registro do paciente
       */
    LerRegistro(codOperadora: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codOperadora }
        });
    }


}